import React from 'react';
import cx from 'classnames';

import TaskGroup from 'modules/tasks/task-group';
import SelectAll from './SelectAll';

const t = {
  titles: {
    NOT_ATTENDED: 'Not reviewed',
    KEEP_AN_EYE: 'Keep an eye',
  },
  no_tasks: {
    NOT_ATTENDED: 'No tasks without review',
    KEEP_AN_EYE: 'No tasks in keep an eye',
  },
};

const List = ({ className, title, groupedTasks }) => {
  const titleText = t.titles[title];
  const emptyList = !groupedTasks || !groupedTasks.length;
  const keepAnEyeList = title === 'KEEP_AN_EYE';

  return (
    <div className={className}>
      <div
        className={cx('list__title', {
          'list__title--eye-list': keepAnEyeList,
        })}
      >
        {titleText}
        <SelectAll title={title} groupedTasks={groupedTasks} />
      </div>
      <div
        className={cx('list__content', {
          'list__content--eye-list': keepAnEyeList,
        })}
      >
        {!emptyList &&
          groupedTasks.map(
            ({
              id,
              tasks,
              handled_by,
              shipper_is_prio,
              has_ftb_shipper,
              has_recovering_shipper,
              has_xdock_shipper_order,
              driver_is_fleet_service,
              status,
              driver,
              vehicle_type,
            }) => {
              return (
                <TaskGroup
                  id={id}
                  key={id}
                  tasks={tasks}
                  owner={handled_by}
                  shipper_is_prio={shipper_is_prio}
                  has_ftb_shipper={has_ftb_shipper}
                  has_recovering_shipper={has_recovering_shipper}
                  has_xdock_shipper_order={has_xdock_shipper_order}
                  driver_is_fleet_service={driver_is_fleet_service}
                  journeyStatus={status}
                  driver={driver}
                  vehicle_type={vehicle_type}
                />
              );
            }
          )}
        {emptyList && <div className="no-tasks">{t.no_tasks[title]}</div>}
      </div>
    </div>
  );
};

export default List;
